import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a date string to Slovak locale format
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  
  // Format for Slovak locale
  try {
    return new Intl.DateTimeFormat('sk-SK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  } catch (error) {
    // Fallback format if Intl is not supported
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}. ${month}. ${year}`;
  }
}
